module.exports = __webpack_public_path__ + "static/media/logo_full_light.4b45d4d5.png";